import Holiday from '@/api/hr/holiday'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return Holiday.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return Holiday.store(data)
  },

  update(context, { id, ...data }) {
    return Holiday.update(id, data)
  },

  generate(context, data) {
    return Holiday.generate(data)
  }
}
